/**
 * 章节配置信息
 */
const chapters = {
    "Prologue": "『 绿生的幻想乡 』",
    "Chapter_1": "BWV 1007",
    "Chapter_2": "海月之誓",
    "Chapter_3": "无尽夏夜",
    "LastChapter": "Main Land"
}

export default chapters